export const DarkColor = {
  white: '#FFFFFF',
  black: '#000000',
  primary: '#BFFF0B',
  success: '#BFFF0B',
  warn: '#EBBC42',
  error: '#860E0E',

  primary_bg: '#111303',
}

// TODO
export const LightColor = DarkColor

export type IThemeColor = typeof DarkColor & typeof LightColor

export default {
  light: LightColor,
  dark: DarkColor,
}
